import { render, staticRenderFns } from "./setting_index.vue?vue&type=template&id=57b89c86&scoped=true&"
import script from "./setting_index.vue?vue&type=script&lang=js&"
export * from "./setting_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b89c86",
  null
  
)

export default component.exports